import React, { useEffect, useState } from 'react';
import { FC } from 'react';
import useTranslations from '@hooks/useTranslation';
import PackageTemplate from '@ui/Package/Package';
import { SUBSCRIPTION_PACKAGES } from '../../constants/packages';
import { IModuleItem } from '../../interfaces/Calendar';
import { Description, Group, Name, Package, Packages, Wrapper } from './TrainingPackage.elements';

export interface TrainingPackageProps {
    modules: IModuleItem[];
}

const TrainingPackageTemplate: FC<TrainingPackageProps> = ({ modules }) => {
    const { t } = useTranslations();

    return (
        modules?.length > 0 && (
            <Wrapper>
                <Description>
                    {t('training.package.label')} <Group>{t('training.package.title')}:</Group>
                </Description>
                <Packages>
                    {modules.map((module, key) => {
                        const subscriptionPackage = SUBSCRIPTION_PACKAGES.find(
                            (subPackage) => subPackage.key === module.module._key
                        );

                        return (
                            <Package key={key}>
                                <PackageTemplate color={subscriptionPackage.color} symbol={subscriptionPackage.icon} />
                                <Name>{subscriptionPackage.title}</Name>
                            </Package>
                        );
                    })}
                </Packages>
            </Wrapper>
        )
    );
};

export default TrainingPackageTemplate;
